module.exports = __webpack_public_path__ + "img/eattake-horizontal-branca-png.8bff4e28.png";